import {
    Sheet,
    SheetContent,
    SheetTitle,
    SheetDescription,
} from '../ui/sheet';
import { Button } from '../ui/button';
import { locales } from '@/i18n/locales';

interface TermsDialogProps {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    locale?: string;
}

export function TermsDialog({ open, onOpenChange, locale = 'es' }: TermsDialogProps) {
    const strings = locales[locale] || locales['es'];

    return (
        <>
            {/* Mobile - Sheet (fullscreen) */}
            <Sheet open={open} onOpenChange={onOpenChange}>
                <SheetContent
                    side="bottom"
                    className="h-screen max-h-screen w-full rounded-none flex flex-col p-4 gap-2 [&>button]:h-8 [&>button]:w-8 [&>button]:right-4 [&>button]:top-4 [&>button>svg]:h-6 [&>button>svg]:w-6"
                >
                    {/* Header - sin border */}
                    <div className="pb-2">
                        <SheetTitle className="font-serif text-sm text-content-primary pr-8">
                            {strings.termsTitle}
                        </SheetTitle>
                        <SheetDescription className="text-xs text-content-secondary pt-1">
                            {strings.termsSubtitle}
                        </SheetDescription>
                    </div>

                    {/* Scrollable content area - espaciado reducido */}
                    <div className="overflow-y-auto flex-1 pr-2">
                        <div className="space-y-2.5 text-[12px] leading-[1.6] text-content-secondary font-light">
                            {strings.termsContent.split('\n').map((line, idx) => {
                                if (line.trim() === `## ${strings.termsTitle}`) {
                                    return null;
                                }

                                if (line.startsWith('##')) {
                                    return (
                                        <h2 key={idx} className="font-serif text-sm font-medium text-content-primary pt-3 first:pt-0">
                                            {line.replace(/^#+\s*/, '').trim()}
                                        </h2>
                                    );
                                }
                                if (line.startsWith('###')) {
                                    return (
                                        <h3 key={idx} className="font-serif text-xs font-medium text-content-primary pt-2">
                                            {line.replace(/^#+\s*/, '').trim()}
                                        </h3>
                                    );
                                }
                                if (line.startsWith('-')) {
                                    return (
                                        <div key={idx} className="flex gap-2 pl-1">
                                            <span className="flex-shrink-0 opacity-60">•</span>
                                            <span>{line.replace('-', '').trim()}</span>
                                        </div>
                                    );
                                }
                                if (line.trim() === '') {
                                    return null; // Sin gaps extras
                                }
                                return (
                                    <p key={idx}>
                                        {line}
                                    </p>
                                );
                            })}
                        </div>
                    </div>

                    {/* Footer with fullwidth button - sin border */}
                    <div className="pt-3 mt-2">
                        <Button
                            onClick={() => onOpenChange(false)}
                            variant="secondary"
                            className="w-full font-light text-sm h-10"
                        >
                            {strings.close}
                        </Button>
                    </div>
                </SheetContent>
            </Sheet>
        </>
    );
}
